import { createContext } from 'react'

const ReduxFirestoreContext = createContext('ReduxFirestore')

export default ReduxFirestoreContext
